/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_LoadingInputs */

const en_us2_today_loading = /** @type {(inputs: Today_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading`)
};

const pt_br2_today_loading = /** @type {(inputs: Today_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando`)
};

const es_419_today_loading = /** @type {(inputs: Today_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando`)
};

const pt_pt2_today_loading = /** @type {(inputs: Today_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A carregar`)
};

const fr_fr2_today_loading = /** @type {(inputs: Today_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement`)
};

const de_de2_today_loading = /** @type {(inputs: Today_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird geladen`)
};

const it_it2_today_loading = /** @type {(inputs: Today_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento`)
};

/**
* | output |
* | --- |
* | "Loading" |
*
* @param {Today_LoadingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_loading = /** @type {((inputs?: Today_LoadingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_LoadingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_loading(inputs)
	if (locale === "es-419") return es_419_today_loading(inputs)
	if (locale === "pt-PT") return pt_pt2_today_loading(inputs)
	if (locale === "fr-FR") return fr_fr2_today_loading(inputs)
	if (locale === "de-DE") return de_de2_today_loading(inputs)
	if (locale === "it-IT") return it_it2_today_loading(inputs)
	return en_us2_today_loading(inputs)
});
export { today_loading as "today.loading" }